import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ButtonWithGAClickButton,
  Card,
  CardActions,
  CardDescription,
  CardGrid,
  CardHeader,
  CardLogo,
  Section,
} from 'common/components';
import {
  STORAGE_CDN_PATH,
  STORAGE_DESIGN_SIGN_UP_HREF,
  STORAGE_DESIGN_PROJECT_HREF,
  STORAGE_ELEMENT_BLOCK,
} from '../../storage-constants';
import {
  cardDescriptionStyle,
  cardHeaderStyle,
  cardLogo,
  storageDesignCard,
  storageDesignCardGrid,
} from './storage-design-card-styles';

type StorageDesignCardProps = {
  isRuRegion: boolean;
  regionId: string;
};

export const StorageDesignCard = ({ isRuRegion, regionId }: StorageDesignCardProps) => {
  const { t } = useTranslation();

  return (
    <Section>
      <CardGrid className={storageDesignCardGrid}>
        <Card className={storageDesignCard} itemScope itemType="https://schema.org/Product">
          <CardLogo
            alt="Лого бесплатного проекта"
            className={cardLogo}
            itemProp="image"
            src={`${STORAGE_CDN_PATH}/banners/free-project-icon.png/free-project-icon.png`}
            title={t('design-card.project.img-label') || ''}
          />
          <CardHeader as="h2" className={cardHeaderStyle} variant="h2" itemProp="name">
            {t('design-card.project.title')}
          </CardHeader>
          <CardDescription className={cardDescriptionStyle} itemProp="description">
            {t('design-card.project.description')}
          </CardDescription>
          <CardActions itemProp="offers" itemScope itemType="https://schema.org/Offer">
            <ButtonWithGAClickButton
              elementBlock={STORAGE_ELEMENT_BLOCK}
              elementName={t('design-card.project.title')}
              elementText={t('design-panel.button-second')}
              href={`${STORAGE_DESIGN_SIGN_UP_HREF}${regionId}`}
              target="_blank">
              {t('design-panel.button-second')}
            </ButtonWithGAClickButton>
            <meta itemProp="priceCurrency" content="RUB" />
            <meta itemProp="price" content="0" />
          </CardActions>
        </Card>

        {isRuRegion && (
          <Card className={storageDesignCard} itemScope itemType="https://schema.org/Product">
            <CardLogo
              alt="Лого онлайн конструктора"
              className={cardLogo}
              itemProp="image"
              src={`${STORAGE_CDN_PATH}/banners/constructor-icon.png/constructor-icon.png`}
              title={t('utp-section.online-constructor.card-title') || ''}
            />
            <CardHeader as="h2" className={cardHeaderStyle} itemProp="name" variant="h2">
              {t('utp-section.online-constructor.card-title')}
            </CardHeader>
            <CardDescription className={cardDescriptionStyle} itemProp="description">
              {t('utp-section.online-constructor.modal-description')}
            </CardDescription>
            <CardActions itemProp="offers" itemScope itemType="https://schema.org/Offer">
              <ButtonWithGAClickButton
                elementBlock={STORAGE_ELEMENT_BLOCK}
                elementName={t('utp-section.online-constructor.card-title')}
                elementText={t('design-panel.button-first')}
                href={STORAGE_DESIGN_PROJECT_HREF}>
                {t('design-panel.button-first')}
              </ButtonWithGAClickButton>
              <meta itemProp="priceCurrency" content="RUB" />
              <meta itemProp="price" content="0" />
            </CardActions>
          </Card>
        )}
      </CardGrid>
    </Section>
  );
};
